'use client';
import { useRef } from 'react';
import { isFunction } from '@s7/utils';
import { useDidUpdate } from '../useDidUpdate/useDidUpdate.js';

/**
 * Возвращает фокус элементу, который последним был активен.
 * Предназначено для использования с FocusTrap, useFocusTrap.
 *
 * Укажите, активна ли ловушка фокуса.
 * Когда она активируется, useFocusReturn сохраняет document.activeElement во внутреннее состояние
 * и фокусирует указанный элемент после деактивации ловушки фокуса.
 *
 * @param opened - Активирована ли ловушка фокуса.
 * @param shouldReturnFocus - Определяет, должен ли фокус возвращаться автоматически, по умолчанию true.
 * */ function useFocusReturn(opened, shouldReturnFocus = true) {
    const lastActiveElement = useRef();
    const returnFocus = ()=>{
        if (lastActiveElement.current && 'focus' in lastActiveElement.current && isFunction(lastActiveElement.current.focus)) {
            var _lastActiveElement_current;
            (_lastActiveElement_current = lastActiveElement.current) == null ? void 0 : _lastActiveElement_current.focus({
                preventScroll: true
            });
        }
    };
    useDidUpdate(()=>{
        let timeout = -1;
        const clearFocusTimeout = (event)=>{
            if (event.key === 'Tab') {
                window.clearTimeout(timeout);
            }
        };
        document.addEventListener('keydown', clearFocusTimeout);
        if (opened) {
            lastActiveElement.current = document.activeElement;
        } else if (shouldReturnFocus) {
            timeout = window.setTimeout(returnFocus, 10);
        }
        return ()=>{
            window.clearTimeout(timeout);
            document.removeEventListener('keydown', clearFocusTimeout);
        };
    }, [
        opened,
        shouldReturnFocus
    ]);
    return returnFocus;
}

export { useFocusReturn };
//# sourceMappingURL=useFocusReturn.js.map
